import { useEffect, useState } from "react";
import { Search, Activity, Filter } from "lucide-react";
import api from "@/lib/api";

const moduleBadge = {
  customers: "crm-badge crm-badge-blue", products: "crm-badge crm-badge-purple",
  sales: "crm-badge crm-badge-orange", payments: "crm-badge crm-badge-green",
  subscriptions: "crm-badge crm-badge-blue", operators: "crm-badge crm-badge-red",
  notes: "crm-badge crm-badge-gray", portal: "crm-badge crm-badge-purple",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [operatorFilter, setOperatorFilter] = useState("");
  const [moduleFilter, setModuleFilter] = useState("");

  const fetch = async () => {
    setLoading(true);
    try {
      const params = {};
      if (operatorFilter) params.operator = operatorFilter;
      if (moduleFilter) params.module = moduleFilter;
      const { data } = await api.get("/audit-logs", { params });
      setLogs(data);
    } catch { /* */ }
    setLoading(false);
  };

  useEffect(() => { fetch(); }, [moduleFilter]);
  const handleSearch = (e) => { e.preventDefault(); fetch(); };

  return (
    <div data-testid="audit-log-page">
      <div className="flex items-center justify-between mb-8">
        <h1 className="crm-heading flex items-center gap-2"><Activity className="w-6 h-6" style={{ color: "var(--crm-accent)" }} /> Registro de Atividades</h1>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <form onSubmit={handleSearch} className="flex-1 relative">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: "var(--crm-text-dim)" }} />
          <input value={operatorFilter} onChange={(e) => setOperatorFilter(e.target.value)} data-testid="audit-operator-filter"
            placeholder="Filtrar por operador..." className="crm-input pl-10" />
        </form>
        <select value={moduleFilter} onChange={(e) => setModuleFilter(e.target.value)} data-testid="audit-module-filter" className="crm-input" style={{ maxWidth: "200px" }}>
          <option value="">Todos os módulos</option>
          <option value="customers">Clientes</option>
          <option value="products">Produtos</option>
          <option value="sales">Vendas</option>
          <option value="payments">Pagamentos</option>
          <option value="subscriptions">Assinaturas</option>
          <option value="operators">Operadores</option>
          <option value="notes">Notas</option>
        </select>
      </div>

      <div className="crm-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="crm-table">
            <thead><tr><th>Data/Hora</th><th>Operador</th><th>Módulo</th><th>Descrição</th><th>Cliente</th></tr></thead>
            <tbody>
              {loading ? (
                [...Array(5)].map((_, i) => <tr key={i}><td colSpan={5}><div className="h-5 rounded animate-pulse" style={{ background: "var(--crm-border)" }} /></td></tr>)
              ) : logs.length === 0 ? (
                <tr><td colSpan={5} className="text-center py-14" style={{ color: "var(--crm-text-dim)" }}>Nenhuma atividade registrada</td></tr>
              ) : (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td style={{ color: "var(--crm-text-muted)", whiteSpace: "nowrap", fontSize: "13px" }}>
                      {new Date(log.created_at).toLocaleString("pt-BR")}
                    </td>
                    <td className="primary">
                      <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0"
                          style={{ background: "var(--crm-accent-subtle)", color: "var(--crm-accent)" }}>
                          {log.operator_name?.charAt(0)?.toUpperCase()}
                        </div>
                        {log.operator_name}
                      </div>
                    </td>
                    <td><span className={moduleBadge[log.module] || "crm-badge crm-badge-gray"}>{log.module}</span></td>
                    <td style={{ color: "var(--crm-text-secondary)", maxWidth: "400px" }}>{log.description}</td>
                    <td style={{ color: "var(--crm-text-muted)" }}>{log.customer_name || "—"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <p className="text-xs mt-3" style={{ color: "var(--crm-text-dim)" }}>{logs.length} registro(s)</p>
    </div>
  );
}
